import React from 'react';
import classNames from 'classnames';

import './styles.less';

type GoAuthProps = {
  onLogin: () => void;
  title?: string;
  description?: string;
  className?: string;
};

const prefixCls = 'canvopix-project-go-auth';

export default function GoAuth(props: GoAuthProps) {
  const {
    onLogin,
    title = 'Sign in to continue',
    description = 'Your projects and favorites are available after signing in.',
    className,
  } = props;

  return (
    <div className={classNames(prefixCls, className)}>
      <div className={`${prefixCls}-inner`}>
        <div className={`${prefixCls}-center`}>
          <div className={`${prefixCls}-card`}>
            <div className={`${prefixCls}-title`}>{title}</div>
            {description ? <div className={`${prefixCls}-desc`}>{description}</div> : null}
            <button type="button" className={`${prefixCls}-btn`} onClick={onLogin}>
              Sign in
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
